/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable')
    .directive('accInfiniteScroll', ['$timeout', function($timeout){
        var
            BOTTOM_OFFSET = 800;

        return {
            link: function($scope, $element) {
                var
                    scrollingElement = $element.find('.scroller'),
                    wrapperElement = scrollingElement.find('div.wrapper');

                $scope.table.hasInfiniteScroll = true;
    
                $scope.$watch('table.entries.length', function(newVal){
                    if(0 < newVal) {
                        evaluateAction();
                    }
                });

                scrollingElement.scroll(function() {
                    evaluateAction();
                });

                function evaluateAction() {
                    $timeout(function() {
                        if ((wrapperElement.height() - (scrollingElement.scrollTop() + scrollingElement.height()) < BOTTOM_OFFSET) ||
                            (scrollingElement.height() > wrapperElement.height())) {
                            $scope.loadMore();
                        }
                    });
                }
            }
        }
    }]);